import React from 'react';
import { IMAGE_BASE_LINK, MINIMAL_HERO } from '../../../../app-constants';
import Articles from '../../../articles/articles';

const RelevantPublications = (props) => {
  const { relevantArticles } = props;
  return (
    <div className="relevant-publications-container">
      <Articles
        articles={relevantArticles}
        customLayoutMode={MINIMAL_HERO}
        imageBaseLink={IMAGE_BASE_LINK}
        customClass={props.minimalHeroClass}
      />
    </div>
  );
};

export default RelevantPublications;
